import Velocity from "velocity-animate";
import { mapGetters, mapActions } from "vuex";
import ClickOutside from "vue-click-outside";

export default {
    name: "LoginProfile",
    data() {
        return {
            isTooltipOpened: false,
            isPopoverOpened: false,
            isNotificationOpened: true
        };
    },
    computed: {
        ...mapGetters("Login", ["user", "imgProfile", "initials"])
    },
    methods: {
        ...mapActions("Login", ["logout", "login"]),
        onLogin() {
            this.isTooltipOpened = !this.isTooltipOpened;
            this.isNotificationOpened = false;
            this.login();
        },
        onLogout() {
            this.isPopoverOpened = false;
            this.logout();
        },
        onClickOutside() {
            this.isTooltipOpened = false;
        },
        onProfileClick() {
            this.isPopoverOpened = !this.isPopoverOpened;
        },
        onPopoverClickOutside() {
            this.isPopoverOpened = false;
        },
        showPopoverAnimation(el, done) {
            Velocity(el, { opacity: "0", translateY: "-30%" }, { duration: 5 });
            Velocity(
                el,
                { opacity: "1", translateY: "0%" },
                { queue: false, duration: 150 },
                { complete: done }
            );
        },
        hidePopoverAnimation(el, done) {
            Velocity(el, { opacity: "1", translateY: "0%" }, { duration: 5 });
            Velocity(
                el,
                { opacity: "0", translateY: "-10%" },
                { queue: false, duration: 100 },
                { complete: done }
            );
        }
    },
    directives: {
        ClickOutside
    }
};



// WEBPACK FOOTER //
// ./src/components/LoginProfile/LoginProfile.js